import React from "react";
import { useTranslation } from "react-i18next";
import Common from "us.common";
import { ILedgerDashboard } from "./Interfaces";
import { Dashboard } from "./Components";
import "./LedgerDashboard.scss";

const { $Drawer } = Common.Components;

const LedgerDashboard: React.FC<ILedgerDashboard> = ({
  journalId,
  drawerProps,
  visible = false,
  width = "1200",
  onClose,
}) => {
  const { t } = useTranslation([
    "US.COLLECTION.ECONOMY",
    "US.COLLECTION.COMMON",
  ]);
  return (
    <$Drawer
      {...drawerProps}
      title={t("US.COLLECTION.ECONOMY:LEDGER_DASHBOARD.JOURNAL_DASHBOARD") + " | " + journalId}
      width={width}
      open={visible}
      onClose={onClose}
      destroyOnClose={true}
    >
      <Dashboard journalId={journalId} onClose={onClose} />
    </$Drawer>
  );
};
export default LedgerDashboard;
